import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { AnswerService } from 'src/app/service/answer.service';
import { QuestionService } from 'src/app/service/question.service';
import { DomSanitizer } from "@angular/platform-browser"; 

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss']
})
export class MultiSelectComponent implements OnInit {
  public ansBody:any = {
    question_label:'',
    question_name:'',
    answer_text:[],
  }
  public format_question_options:any = [];
  public page_image_show :number = 1;
  public componentType:string = "";
  constructor(
    public qService:QuestionService,
    public aService:AnswerService,
    public notifier:NotifierService,
    public sanitizier:DomSanitizer,
  ) {
    this.componentType = this.qService.questionType.MULTI_SELECT
    this.qService.refreshAnsBody
    .subscribe((question_type:string) =>{
      if (question_type == this.componentType) {
        this.resetAnsBody();
      }
    })
   }

  ngOnInit(): void {
    this.formatQuestionOption();
  }

  next(){
    // console.log(this.ansBody)
    if (!this.ansBody.answer_text.length) {
      this.notifier.notify('error',"Please select atleast one value");
    }
    else
    {
      this.ansBody.question_label = this.qService.currentQuestion.question_label;
      this.ansBody.question_name = this.qService.currentQuestion.question_name;
      this.aService.submitAnswer(this.ansBody);
      // this.resetAnsBody();
      // setTimeout(() => {
      //   this.resetAnsBody();
      // }, 100);
    }
  }

  makeSrcUrl(text:any){
    let img_tag = text.split('<br>');
    let img_src = img_tag[1].split(' ');
    let url = img_src[1].split('=')[1];
    // console.log(url);
    // return this.sanitizier.bypassSecurityTrustResourceUrl(url);
    // return url;
    return 'https://source.unsplash.com/user/c_v_r/100x100';
  }

  formatQuestionOption(){
    this.format_question_options = this.qService.currentQuestion.options.slice((this.page_image_show-1)*6,this.page_image_show*6);
  }

  Image_next(){
    if(this.page_image_show*6 < this.qService.currentQuestion.options.length)
    {
      this.page_image_show += 1;
      this.formatQuestionOption();
    }
  }

  multiOptionsSwitch(text:any,ind:number){
    let find_val = this.ansBody.answer_text.findIndex((va:any) => va === text);
    if(find_val != -1){
      this.ansBody.answer_text.splice(find_val,1);
    }
    else
    {
      this.ansBody.answer_text.push(text);
    }
    // console.log(this.ansBody.answer_text);
  }

  checkedElement(text:any){
    let find_val = this.ansBody.answer_text.find((va:any) => va === text);
    if(find_val){
      return 1;
    }
    return 0;
  }

  resetAnsBody(){
    this.ansBody ={
      question_label:'',
      question_name:'',
      answer_text:[],
    }
  }
}
